const PARTYTOWN_FILES = ['external-component-renderer.umd.js']

const DIST_URL = 'services/wix-thunderbolt/dist/'

export const getExternalComponentRendererUrl = (staticServerUrl: string) =>
	`${staticServerUrl}${DIST_URL}${PARTYTOWN_FILES[0]}`
